import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { VIDEO_ID_ATTENDED_AUTHORIZATION } from "../queriesAndMutations/authQuery";
import {
  CHANGE_USER_STATUS_VIDEO_IDENTIFICATION,
  CHANGE_USER_VIDEO_IDENTIFICATION_ID,
  CREATE_LOG_VIDEO_IDENT,
} from "../queriesAndMutations";
import { USER_VIDEO_IDENT_STATUS } from '../constants/user'
import { useMe } from "../myHooks";
import "../styles/legacy/style.scss";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppBar from "../components/AppBar";
import Footer from "../components/Footer";
import { VIDEO_ID_TYPES } from "../constants/video_id_types";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from 'react-i18next';

const axios = require("axios");

const useStyles = makeStyles(() => ({
  videoIDClass: {
    maxHeight: "900px",
  },
  circularProgressWrapper: {
    display: "flex",
    justifyContent: "center",
  },
}));

const detectVideoIdType = (customer) => {
  let videoIdTypeDetected = "";
  let documentType = customer.documentType;

  if (documentType === "DRIVER_LICENSE") {
    videoIdTypeDetected = VIDEO_ID_TYPES.find(
      (ele) =>
        ele["countryName"] === customer.nationality &&
        ele["type"] === "DriverLicense"
    );
  } else {
    if (documentType === "NATIONAL_ID_CARD") {
      videoIdTypeDetected = VIDEO_ID_TYPES.find(
        (ele) =>
          ele["countryName"] === customer.nationality &&
          ele["type"] === "IdCard"
      );
    } else {
      videoIdTypeDetected = VIDEO_ID_TYPES.find(
        (ele) =>
          ele["countryName"] === customer.nationality &&
          ele["type"] === "Passport"
      );
    }
  }

  if (videoIdTypeDetected === undefined){
    if (documentType === "DRIVER_LICENSE") {
      videoIdTypeDetected = VIDEO_ID_TYPES.find(
        (ele) =>
          ele["countryName"] === customer.countryOfResidence &&
          ele["type"] === "DriverLicense"
      );
    } else {
      if (documentType === "NATIONAL_ID_CARD") {
        videoIdTypeDetected = VIDEO_ID_TYPES.find(
          (ele) =>
            ele["countryName"] === customer.countryOfResidence &&
            ele["type"] === "IdCard"
        );
      } else {
        videoIdTypeDetected = VIDEO_ID_TYPES.find(
          (ele) =>
            ele["countryName"] === customer.countryOfResidence &&
            ele["type"] === "Passport"
        );
      }
    }
  }

  return videoIdTypeDetected;
}

const VideoIDAttendedPage = () => {
  const { data: { me: userData } = {} } = useMe();
  const customer = userData.customer || {};
  const videoIdTypeDetected = detectVideoIdType(customer);
  const { data } = useQuery(VIDEO_ID_ATTENDED_AUTHORIZATION);
  const [changeUserVideoIdentStatus] = useMutation(CHANGE_USER_STATUS_VIDEO_IDENTIFICATION);
  const [changeUserVideoIdentId] = useMutation(CHANGE_USER_VIDEO_IDENTIFICATION_ID);
  const [videoVerifyStatus, setVideoVerifyStatus] = useState("Unverified");
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const classes = useStyles();
  const [createLogVideoIdent] = useMutation(CREATE_LOG_VIDEO_IDENT);
  const { t } = useTranslation();

  const getDataOfRecordedVideo = async (video_record_id) => {
    await axios.get(`${window.location.origin}/video-id/get-video/${video_record_id}`)
      .then((response) => {
        let videoStatus =
          response.data.status === "Completed"
            ? USER_VIDEO_IDENT_STATUS.PASSED
            : USER_VIDEO_IDENT_STATUS.DENIED;
        setVideoVerifyStatus(videoStatus);
        changeUserVideoIdentStatus({
          variables: {
            id: +userData.id,
            videoIdentificationStatus: videoStatus,
          },
        }).then(() => console.log("update video status successfully!")).catch(() => {});
        changeUserVideoIdentId({
          variables: {
            id: +userData.id,
            videoIdentificationId: video_record_id,
          },
        }).then(() => console.log("update video record id successfully!")).catch(() => {});
      })
  };

  const loadScript = (data) => {
    const script = document.createElement("script");
    script.src = data.videoIDAttendAuthorization.scriptSrc;
    document.head.appendChild(script);
    script.onload = function () {
      let EID = window.EID;
      // let videoId = EID.videoIDAttended("#video", {
      //   lang: "en",
      // });
      let videoId = EID.videoIDAttended("#video", {
        lang: "en",
      });
      videoId.turnOn();
      videoId.start({
        authorization: data.videoIDAttendAuthorization.authorization,
        idType: videoIdTypeDetected.id,
      });
      videoId.on("phaseStarting", function (phase) {
        if (phase.name === "FRONT") {
          console.log(phase.name + " - Starting");
          setScriptLoaded(true);
        }
        phase.continue();
      });
      videoId.on("completed", function (video) {
        videoId.turnOff();
        getDataOfRecordedVideo(video.id);
        alert("VideoId record successfully!");
      });
      videoId.on("failed", function (error) {
        console.log('error VideoId')
        const error_data = error.error;
        console.log(error_data)
        createLogVideoIdent({
          variables: {
            email: userData.email,
            error: error_data.error,
            message: error_data.message,
          }
        }).catch(() => {})
      });
    };
  };

  useEffect(() => {
    if (data && data.videoIDAttendAuthorization) {
      console.log('loadScript running...')
      loadScript(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div className="page-user">
      <AppBar />
      <div className="page-content">
        <div className="container">
          <p className="text-center">
            { t('VideoID Page, status') }: {videoVerifyStatus}
          </p>
          <p className="text-center">
            <strong>{ t('Only available from 9-5pm Vaduz, Liechtenstein time.') }</strong>
          </p>
          {scriptLoaded ? (
            ""
          ) : (
            <div className={classes.circularProgressWrapper}>
              <CircularProgress />
            </div>
          )}
          <div id="video" className={classes.videoIDClass} />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default VideoIDAttendedPage;
